import $moment from 'moment'
import { getShifts, postShift, getBills } from "@/modules/booking/api";
import { getList as getTables } from '@/modules/settings/components/Tables/api'

let date = new Date()
if (date.getHours() < 6) {
  date = $moment(date).subtract(1, 'days').toDate()
}

const BookingStore = {
  state: {
    shift: null,
    deskStatuses: [
      { label: 'Забронирован', color: '#A5D6A7', key: 'booked' },
      // {label: 'Ожидание', color: '#7E57C2', key: 'waiting'},
      { label: 'Сели', color: '#3cbc80', key: 'sat' },
      { label: 'Рассчитан', color: '#424242', key: 'served' }
    ],
    conflictOrders: [],
    date: new Date(),
    loading: false,
    tables: [],
    bills: [],
    timeRows: []
  },
  getters: {
    openedShift: state => state.shift,
    deskStatuses: state => state.deskStatuses,
    conflictOrders: state => state.conflictOrders,
    bookingDate: state => state.date,
    bookingLoading: state => state.loading,
    bookingTables: state => state.tables,
    bookingBills: state => state.bills,
    bookingTimeRows: state => state.timeRows
  },
  mutations: {
    SET_OPENED_SHIFT: (state, shift) => {
      shift.closed = shift.isclose
      state.shift = shift
    },
    SET_CONFLICT_ORDERS: (state, orders) => state.conflictOrders = orders,
    DELETE_CONFLICT_ORDER: (state, order) => {
      if (!state.conflictOrders.length) return

      let index = state.conflictOrders.findIndex(({ id }) => order.id === id)
      if (index >= 0) {
        state.conflictOrders.splice(index, 1)
      }
    },
    SET_LOADING: (state, value) => state.loading = value,
    SET_BOOKING_DATE: (state, date) => state.date = date,
    SET_TABLES: (state, tables) => state.tables = tables,
    SET_BILLS: (state, bills) => state.bills = bills,
    SET_BOOKING_TIME_ROWS: (state, rows) => state.timeRows = rows,
    SET_DESK_STATUSES: (state, statuses) => state.deskStatuses = statuses,
    SET_TABLE_ORDER: (state, order) => {
      if (!state.shift) return
      if (!state.shift.orders) state.shift.orders = []

      let index = state.shift.orders.findIndex(({ id }) => order.id === id)

      if (index >= 0) {
        state.shift.orders.splice(index, 1, order)
      } else {
        state.shift.orders.push(order)
      }
    },
    DELETE_TABLE_ORDER(state, order) {
      if (!state.shift || !state.shift.orders) return

      let index = state.shift.orders.findIndex(({ id }) => order.id === id)
      if (index >= 0) {
        state.shift.orders.splice(index, 1)
        // state.shift.orders[index].deleted = true
      }
    }
  },
  actions: {
    async LoadShift(context, force) {
      if (context.state.loading && !force) return

      context.commit('SET_LOADING', true)

      const date = $moment(context.state.date).format('YYYY-MM-DD');
      let params = {
        'dayStart[after]': date,
        'dayStart[before]': date,
      }

      let response = await getShifts(params)
      if (response.data.items.length) {
        context.commit('SET_OPENED_SHIFT', response.data.items[0])
      } else {
        let postResponse = await postShift({ dayStart: date })
        context.commit('SET_OPENED_SHIFT', postResponse.data)
      }

      context.commit('SET_LOADING', false)
    },
    async loadDesks(context, params) {
      let response = await getTables(params)
      context.commit('SET_TABLES', response.data.items
        .filter(desk => desk.active)
        .map(table => ({ ...table, orders: [] }))
      )
    },
    async loadBills(context, params) {
      let response = await getBills(params)
      context.commit('SET_BILLS', response.data.items)
    }
  }
}

export default BookingStore



// WEBPACK FOOTER //
// ./src/modules/booking/store.js